<template>
  <transition-expand>
    <ul v-if="isListExpanded" class="products-item-matching-list">
      <attribute-matching-list-item
        v-for="(attributeMatch, index) in attributeMatches"
        :key="index"
        :attribute-match="attributeMatch"
      />
    </ul>
  </transition-expand>
</template>

<script>
// @flow
import TransitionExpand from './TransitionExpand.vue'
import AttributeMatchingListItem from './AttributeMatchingListItem.vue'

export default {
  components: {
    TransitionExpand,
    AttributeMatchingListItem
  },
  props: {
    isListExpanded: {
      type: Boolean,
      default: () => false
    },
    attributeMatchesSuccess: {
      type: Array,
      default: () => []
    },
    attributeMatchesFail: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    attributeMatches (): Array<Object> { // Array<AttributeMatch>
      return [...this.attributeMatchesSuccess, ...this.attributeMatchesFail]
    }
  }
}
</script>

<style src="./attribute-matching-list.scss" />
